import React, { useState, useEffect } from 'react';
import CinematicIntro from './CinematicIntro';
import RealisticIntro from './RealisticIntro';
import ServiceBubblesHome from './ServiceBubblesHome';
import { useNavigate, useLocation } from 'react-router-dom';

const HomePage = ({ user, onLogout, skipIntro = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Vérifier si on vient de la page login avec demande de retour au portail
  const fromLogin = location.state?.fromLogin === true;
  
  // Si user connecté → bulles direct
  // Si skipIntro ou fromLogin → portail direct (pas de vidéo)
  // Sinon → intro complète
  const [showIntro, setShowIntro] = useState(!user && !skipIntro && !fromLogin);
  const [introCompleted, setIntroCompleted] = useState(!!user);
  const [showPortalOnly, setShowPortalOnly] = useState(skipIntro || fromLogin);

  const handleIntroComplete = (action, userData) => {
    setShowIntro(false);
    setShowPortalOnly(false);
    
    if (action === 'client') {
      navigate('/login');
    } else if (action === 'visitor') {
      navigate('/register-free');
    } else {
      setIntroCompleted(true);
    }
  };

  return (
    <>
      {showIntro && !showPortalOnly && (
        <RealisticIntro onComplete={handleIntroComplete} />
      )}
      {showPortalOnly && !user && (
        <RealisticIntro onComplete={handleIntroComplete} startAtPortal={true} />
      )}
      {introCompleted && (
        <ServiceBubblesHome 
          user={user} 
          onLogout={onLogout}
        />
      )}
    </>
  );
};

export default HomePage;
